import React from 'react';
import Modal from 'react-modal';
import '../utils/ConfirmationModal.css';

// Set app element for accessibility
if (typeof window !== 'undefined') {
  Modal.setAppElement('#root');
}

const ConfirmDeleteModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = "Confirmer la suppression",
  message,
  isLoading = false
}) => {
  return (
    <Modal
      isOpen={show}
      onRequestClose={onHide}
      contentLabel="Confirmation de suppression"
      className="Modal"
      overlayClassName="Overlay"
    >
      <h2>{title}</h2>
      <p>{message || "Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible."}</p>
      <div className="d-flex gap-3">
        <button 
          onClick={onConfirm} 
          className="btn btn-danger"
          disabled={isLoading}
          style={{ opacity: isLoading ? 0.6 : 1 }}
        >
          {isLoading ? 'Suppression...' : 'Confirmer'}
        </button>
        <button 
          onClick={onHide} 
          className="btn btn-secondary"
          disabled={isLoading}
        >
          Annuler
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
